import { render, staticRenderFns } from "./SnsSharing.vue?vue&type=template&id=2da8efa0&"
import script from "./SnsSharing.vue?vue&type=script&lang=js&"
export * from "./SnsSharing.vue?vue&type=script&lang=js&"
import style0 from "./SnsSharing.vue?vue&type=style&index=0&id=2da8efa0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports